import NotesView from './NotesView'

export * from './NotesView'
export default NotesView
